import {
  DEFAULT_PLAYER_GAME_ORDERING,
  baseFetchPlayerGameStats,
  baseFetchPlayerSpanStats,
  baseFetchPlayerStreakStats,
  baseFetchTeamGameStats,
} from './api';
import API_URLS from './api_urls';

export const fetchNcaaWbbPlayerGameStats = async (
  filters: Array<string>,
  signOut: () => boolean,
  page = 0,
  sortBy = DEFAULT_PLAYER_GAME_ORDERING,
  uuid?: string,
) => baseFetchPlayerGameStats(
  API_URLS.ncaawbb.player_game_finder, filters, signOut, page, sortBy, uuid
);

export const fetchNcaaWbbPlayerStreakStats = async (
  filters: Array<string>,
  signOut: () => boolean,
  page = 0,
  sortBy = DEFAULT_PLAYER_GAME_ORDERING,
  uuid?: string,
) => baseFetchPlayerStreakStats(
  API_URLS.ncaawbb.player_streak_finder, filters, signOut, page, sortBy, uuid
);

export const fetchNcaaPlayerSpanStats = async (
  filters: Array<string>,
  signOut: () => boolean,
  page = 0,
  sortBy = DEFAULT_PLAYER_GAME_ORDERING,
  uuid?: string,
) => baseFetchPlayerSpanStats(
  API_URLS.ncaawbb.player_span_finder, filters, signOut, page, sortBy, uuid
);

export const fetchNcaaWbbTeamGameStats = async (
  filters: Array<string>,
  signOut: () => boolean,
  page = 0,
  sortBy = DEFAULT_PLAYER_GAME_ORDERING,
  uuid?: string,
) => baseFetchTeamGameStats(
  API_URLS.ncaawbb.team_game_finder, filters, signOut, page, sortBy, uuid
);

export const fetchNcaaWbbTeamStreakStats = async (
  filters: Array<string>,
  signOut: () => boolean,
  page = 0,
  sortBy = DEFAULT_PLAYER_GAME_ORDERING,
  uuid?: string,
) => baseFetchTeamGameStats(
  API_URLS.ncaawbb.team_streak_finder, filters, signOut, page, sortBy, uuid
);

export const fetchNcaaWbbTeamSpanStats = async (
  filters: Array<string>,
  signOut: () => boolean,
  page = 0,
  sortBy = DEFAULT_PLAYER_GAME_ORDERING,
  uuid?: string,
) => baseFetchTeamGameStats(
  API_URLS.ncaawbb.team_span_finder, filters, signOut, page, sortBy, uuid
);
